import React, { useState, useEffect, useRef } from "react";
import { styled } from "baseui";
import ContextMenu from "../context-menu/ContextMenu";
import ContextContainer from "../context-container/ContextContainer";
import { TREE_CONTEXT_MENU_ITEMS } from "../../constants/AppEnums";
import { LabelXSmall } from "baseui/typography";
import * as AppConstants from "../../constants/AppConstants";
import { TREE_ICONS } from "../../constants/IconConstants";
import { Input } from "baseui/input";
import { TreeLabelInteractable } from "baseui/tree-view";
import { SIZE } from "baseui/button";
import WrapperContainer from "../wrapper-item/WrapperContainer";

const Label = styled("div", {
  display: "flex",
  paddingRight: "5px",
  alignItems: "center",
  cursor: "pointer",
});
export const convertFolderToLabel = (
  folders,
  onContextMenuItemClick,
  onLabelChange,
  onLabelClick,
  isInteractable
) => {
  return (folders || []).map((folder) => {
    return {
      label: (node) => (
        <TreeItemLabel
          node={node}
          onContextMenuItemClick={({ action, node }) =>
            onContextMenuItemClick({ action, node })
          }
          onLabelChange={(node, label) => onLabelChange(node, label)}
          onLabelClick={(node) => onLabelClick(node)}
          isInteractable={isInteractable}
        />
      ),
      isExpanded: folder?.isExpanded,
      name: folder.name,
      isEditing: folder?.isEditing,
      path: folder?.path,
      id: folder.id,
      isSelected: folder?.isSelected,
      type: folder?.type,
      children:
        folder.children && folder.children.length !== 0
          ? convertFolderToLabel(
              folder.children,
              onContextMenuItemClick,
              onLabelChange,
              onLabelClick,
              isInteractable
            )
          : [],
    };
  });
};
function useOutsideClick(ref, callback) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
}
const EditingLabel = ({ node, onLabelChange }) => {
  const [nodeName, setNodeName] = useState(node.name);
  const [initialValue, setInitialValue] = useState(node.name);
  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef, () => {
    handleBlur();
    // Dispatch action to set `isEditing` to false
  });
  useEffect(() => {
    // Update the initialValue when the component mounts or the node changes
    setInitialValue(node.name);
  }, [node]);

  const handleBlur = (e) => {
    // Perform onLabelChange only if the value has changed
    if (nodeName && nodeName !== "" && nodeName !== initialValue) {
      onLabelChange(node, nodeName);
    }
    node.isEditing = false;
  };

  return (
    <Label>
      <span onClick={handleBlur}>{TREE_ICONS[node.type]}</span>
      <div ref={wrapperRef}>
        <Input
          size={SIZE.mini}
          autoFocus
          value={nodeName}
          onChange={(e) => setNodeName(e.target.value)}
          // onBlur={handleBlur}
          $style={{
            height: AppConstants.TREE_ITEM_HEIGHT,
            width: AppConstants.TREE_ITEM_WIDTH,
          }}
        />
      </div>
    </Label>
  );
};
const StandardLabel = ({
  node,
  isInteractable,
  onLabelClick,
  onContextMenuItemClick,
}) => {
  return (
    <WrapperContainer wrapper={TreeLabelInteractable} enabled={isInteractable}>
      <ContextContainer
        enabled={node.isSelected}
        node={node}
        menu={() => (
          <ContextMenu
            items={TREE_CONTEXT_MENU_ITEMS[node.type]}
            onMenuItemClick={(action) =>
              onContextMenuItemClick({ action, node })
            }
          />
        )}
      >
        <Label
          onContextMenu={(e) => e.preventDefault()}
          onClick={() => onLabelClick(node)}
        >
          {TREE_ICONS[node.type]}
          <LabelXSmall
            $style={{
              fontWeight: node.isSelected ? "bold" : "normal",
              padding: "10px",
            }}
          >
            {node.name}
          </LabelXSmall>
        </Label>
      </ContextContainer>
    </WrapperContainer>
  );
};

function TreeItemLabel({
  node,
  onContextMenuItemClick,
  onLabelChange,
  onLabelClick,
  isInteractable,
}) {
  const [nodeName, setNodeName] = useState(node.name);

  useEffect(() => {
    setNodeName(node.name);
  }, [node]);

  return node.isEditing && node.isSelected ? (
    <EditingLabel
      node={node}
      nodeName={nodeName}
      setNodeName={setNodeName}
      onLabelChange={onLabelChange}
    />
  ) : (
    <StandardLabel
      node={node}
      isInteractable={isInteractable}
      onLabelClick={onLabelClick}
      onContextMenuItemClick={onContextMenuItemClick}
    />
  );
}

export default TreeItemLabel;
